module.exports = __webpack_public_path__ + "assets/htu-10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-10.jpg
// module id = 1197
// module chunks = 7